import { useMemo, useState } from 'react'
import usePortfolios from 'hooks/models/usePortfolios'
import PortfolioSelect from 'components/PortfolioSelect'
import PortfoliosManager from 'components/cards/portfolios/PortfoliosManager'

export const UserPortfoliosSelect = () => {
  const [isOpenPortfolioManager, setIsOpenPortfolioManager] = useState(false)
  const [portfolioId, setPortfolioId] = useState(null)

  const {
    selectedPortfolios: {
      data: persistedSelectedPortfolios,
      isLoading: isPersistedSelectedPortfoliosLoading,
    },
    updateSelectedPortfolios: {
      mutation: updatePersistedSelectedPortfolios,
      isLoading: isUpdatePersistedSelectedPortfoliosLoading,
    },
    portfolios: { data: portfolios },
    portfoliosById: { data: portfoliosById },
  } = usePortfolios()

  const portfolioToEdit = useMemo(() => {
    return portfolios?.find((portfolio) => portfolio.id === portfolioId)
  }, [portfolios, portfolioId])

  const handlePortfolioEdit = (id) => {
    setPortfolioId(id)
    setIsOpenPortfolioManager(true)
  }

  const handleApply = (portfolioIds) => {
    updatePersistedSelectedPortfolios(portfolioIds)
  }

  return (
    <>
      <PortfolioSelect
        selectedPortfolios={persistedSelectedPortfolios}
        onChange={() => {}} // No onChange needed for header, only onApply
        onApply={handleApply}
        portfolios={portfolios}
        portfoliosById={portfoliosById}
        isLoading={
          isUpdatePersistedSelectedPortfoliosLoading || isPersistedSelectedPortfoliosLoading
        }
        onPortfolioEdit={handlePortfolioEdit}
        buttonText="Portfolio"
        showApplyButton={true}
        showPortfolioNames={false}
        fullWidth={false}
        size="small"
        variant="header"
      />
      <PortfoliosManager
        portfolio={portfolioToEdit}
        isOpenPortfolio={isOpenPortfolioManager}
        setIsOpenPortfolio={setIsOpenPortfolioManager}
      />
    </>
  )
}

export default UserPortfoliosSelect
